import { pricingPlans } from '@/lib/pricingPlans';
import { planManifesto } from '@/lib/planManifesto';
import { useLanguage } from '@/lib/LanguageContext';

/**
 * Cierre de la página de precios: una frase grande y tres tarjetas numeradas
 * que resumen qué aporta cada plan.
 */
export default function PlanManifesto() {
  const { lang } = useLanguage();
  const content = planManifesto[lang] || planManifesto.ES;
  const planNames = (pricingPlans[lang] || pricingPlans.ES).plans.map((plan) => plan.name);

  return (
    <section className="bg-white border-t border-gray-100 py-24">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-gray-900 text-center max-w-4xl mx-auto mb-16">
          {content.headlineBefore}
          <span className="text-brand-blue">{content.headlineHighlight}</span>
          {content.headlineAfter}
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          {content.cards.map((card, i) => (
            <div key={card.number} className="rounded-2xl border border-gray-200 p-8">
              <span className="text-xs font-black tracking-[0.2em] text-gray-400">{card.number}</span>
              <span className="block h-px bg-gray-200 my-6" />
              <h3 className="font-heading font-black text-2xl text-gray-900 tracking-tight mb-2">{planNames[i]}</h3>
              <p className="text-gray-500 font-light">
                {card.before}
                <strong className="font-bold text-gray-900">{card.bold}</strong>
                {card.after}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-lg text-gray-500 font-light mt-16">
          {content.footerBefore}
          <span className="font-bold text-gray-900">Smart</span>
          <span className="font-bold text-brand-blue">POS</span>
        </p>
      </div>
    </section>
  );
}